import { Icon } from "components/Icon/Icon";

import type React from "react";
import type { IconType } from "components/Icon/Icon";

import "./Panel.scss";

interface PanelProps {
  className: string;
  title: string;
  children: React.ReactNode;
  icon?: IconType;
  iconAction?: () => void;
  buttonTooltip?: string;
  disabled?: boolean;
  testId?: string;
  id?: string;
}

export const Panel = (props: PanelProps) => (
  <div className={`col ${props.className}`} data-testid={props.testId} id={props.id}>
    {props.disabled && <div className="custom-synonyms-sub-panel-disabled-area" />}
    <div className="panel-title" data-testid={`${props.testId ?? "panel"}-title`}>
      {props.title}
      {props.icon && props.iconAction && (
        <button
          className="k-button k-icon-button"
          onClick={props.iconAction}
          type="button"
          title={props.buttonTooltip || ""}
          data-testid={`${props.testId ?? "panel"}-action`}
        >
          <Icon type={props.icon} className="panel-icon" />
        </button>
      )}
    </div>
    <div className="panel-content" data-testid={`${props.testId ?? "panel"}-content`}>
      {props.children}
    </div>
  </div>
);
